import { Box, Typography } from '@mui/material';
import React from 'react';

interface IProps {
  body: string;
  createdDate: string;
  owner: { name: string; email: string; hubspotOwnerId?: string };
}

const NoteCard = ({ body, createdDate, owner }: IProps) => {
  return (
    <Box sx={{ mb: 2, border: '1px solid grey', p: 2 }}>
      <Typography fontWeight="bold">Nota del {createdDate}</Typography>
      {owner && owner.hubspotOwnerId ? (
        <Typography sx={{ fontSize: '12px' }}>
          scritta da {owner.name ? owner.name : '-'} -{' '}
          {owner.email ? owner.email : '-'}
        </Typography>
      ) : null}
      <Typography mt={2}>{body}</Typography>
    </Box>
  );
};

export default NoteCard;
